import { ImportEmployeesToSMSchema, ImportEmployeesToSMSchemaType } from './schema'

const Form = () => {
  const defaultValues: ImportEmployeesToSMSchemaType = {
    effectiveAt: new Date(),
    employeeIds: [],
    numberOfRestDaysInCents: null,
    employeeSelection: { type: 'manual', ids: [] },
  }

  return {
    defaultValues,
    schema: ImportEmployeesToSMSchema(),
  }
}

export { Form }
